import { allowViewAccountTrainCourseList } from '../../../../backend/features/permissions';
import { accountTrainCoursesViewName } from '../../../../backend/features/train-courses';
import { getAccountStorage } from '@juvare/contact-management/backend/features/accounts';
import { AuthError } from '@juvare/platform-app/App';
import { implementTypedPlatformFunction } from '@juvare/platform-sdk-react/backend/features/typed-platform-functions';
import { z } from 'zod';
export const getAccountTrainCoursesFunctionDef = {
    name: 'getAccountTrainCourses',
    requestSchema: z.object({
        accountId: z.string().uuid(),
        limit: z.number().optional(),
        offset: z.number().optional(),
    }),
    responseSchema: z.object({
        data: z
            .object({
            trainId: z.number(),
            completionDate: z.number(),
            courseName: z.string(),
        })
            .array(),
        total: z.number(),
    }),
};
export const getAccountTrainCoursesFunctionImpl = implementTypedPlatformFunction(getAccountTrainCoursesFunctionDef, (context, { accountId, limit, offset }) => {
    const { data } = getAccountStorage(context).get(accountId);
    if (accountId !== context.userState.id && !allowViewAccountTrainCourseList(context.userState, data.orgRole, data.orgStatus)) {
        throw new AuthError('Not authorized');
    }
    const view = context.view(accountTrainCoursesViewName);
    const trainingsList = view.list({
        filter: [
            {
                column: 'accountId',
                value: accountId,
                op: '=',
            },
        ],
        limit,
        offset,
    });
    return { data: trainingsList.rows, total: trainingsList.total };
});
